import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { Observable } from 'rxjs';
import { GlobleSettingsService } from '../service/globle-settings.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router, public platform: Platform, public globlesetting: GlobleSettingsService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      // console.log(this.platform.is('android')); 
      // For web Browser
      if(this.globlesetting.isBrowserDevice){
        var postData = { 
          firstname: "Website", 
          lastname: "Browser", 
          deviceid: "Website", 
          location: "Website",
          batterylevel: "Website",
          latitude: "Website",
          longitude: "Website",
          ipaddress: 'Website',
          ssid: 'Web Browser Internet',
          appVersion: "1.0.8",
              };
        console.log(postData);
        localStorage.setItem('currentUser', JSON.stringify(postData));
      }

      if (!localStorage.getItem('currentUser')) {
        this.router.navigate(['/intro']);
      }

    return true;
  }
  
}
